exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".usc-store.dt {\r\n    padding: 0px 25px;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/components/usc-store/usc-uploaded-documents/usc-uploaded-documents.component.css
// module id = ../../../../../src/app/components/usc-store/usc-uploaded-documents/usc-uploaded-documents.component.css
// module chunks = main